{
  "login": {
    "tagline": "Quản lý lớp học\nnhẹ đầu hơn.",
    "description": "Học sinh, điểm danh, học phí: tất cả trong một nền tảng dành cho giáo viên và gia sư Việt Nam.",
    "title": "Đăng nhập",
    "subtitle": "Chào mừng bạn quay lại. Nhập thông tin để tiếp tục.",
    "or": "hoặc",
    "email": "Email",
    "password": "Mật khẩu",
    "passwordPlaceholder": "Nhập mật khẩu",
    "forgotPassword": "Quên mật khẩu?",
    "submit": "Đăng nhập",
    "submitting": "Đang đăng nhập...",
    "noAccount": "Chưa có tài khoản?",
    "signUp": "Dùng thử miễn phí",
    "invalidCredentials": "Email hoặc mật khẩu không đúng.",
    "noOrganization": "Bạn không còn thuộc tổ chức nào."
  },
  "register": {
    "tagline": "Bắt đầu quản lý\nlớp học của bạn.",
    "description": "Tạo tài khoản và dùng thử miễn phí 30 ngày, không cần thẻ.",
    "title": "Tạo tài khoản",
    "subtitle": "Điền thông tin bên dưới để bắt đầu sử dụng LopHoc.app.",
    "fullName": "Họ và tên",
    "fullNamePlaceholder": "Nguyễn Văn A",
    "email": "Email",
    "password": "Mật khẩu",
    "passwordPlaceholder": "Tối thiểu 8 ký tự",
    "orgName": "Tên lớp / trung tâm",
    "orgNamePlaceholder": "VD: Lớp Toán Cô Hạnh",
    "submit": "Tạo tài khoản",
    "submitting": "Đang tạo tài khoản...",
    "hasAccount": "Đã có tài khoản?",
    "signIn": "Đăng nhập",
    "emailExists": "Email này đã được sử dụng.",
    "consent": "Bằng việc tạo tài khoản, bạn đồng ý với",
    "consentTerms": "Điều khoản dịch vụ",
    "consentAnd": "và",
    "consentPrivacy": "Chính sách bảo mật"
  },
  "forgotPassword": {
    "title": "Quên mật khẩu",
    "subtitle": "Nhập email của bạn và chúng tôi sẽ gửi link đặt lại mật khẩu.",
    "submit": "Gửi link đặt lại",
    "submitting": "Đang gửi...",
    "successTitle": "Kiểm tra email của bạn",
    "successMessage": "Nếu email tồn tại trong hệ thống, chúng tôi đã gửi link đặt lại mật khẩu. Vui lòng kiểm tra hộp thư.",
    "backToLogin": "Quay lại đăng nhập"
  },
  "resetPassword": {
    "title": "Đặt lại mật khẩu",
    "subtitle": "Nhập mật khẩu mới cho tài khoản của bạn.",
    "newPassword": "Mật khẩu mới",
    "confirmPassword": "Xác nhận mật khẩu",
    "confirmPlaceholder": "Nhập lại mật khẩu",
    "submit": "Đặt lại mật khẩu",
    "submitting": "Đang xử lý...",
    "successTitle": "Đặt lại mật khẩu thành công",
    "successMessage": "Bạn có thể đăng nhập với mật khẩu mới.",
    "minLength": "Mật khẩu phải có ít nhất 8 ký tự.",
    "mismatch": "Mật khẩu xác nhận không khớp.",
    "invalidToken": "Token không hợp lệ. Vui lòng thử lại từ email."
  },
  "verifyEmail": {
    "verifying": "Đang xác thực email...",
    "pleaseWait": "Vui lòng chờ trong giây lát.",
    "successTitle": "Email đã được xác thực",
    "successMessage": "Tài khoản của bạn đã sẵn sàng. Hãy đăng nhập để tiếp tục.",
    "errorTitle": "Xác thực thất bại",
    "errorMessage": "Link xác thực không hợp lệ hoặc đã hết hạn.",
    "missingToken": "Thiếu mã xác thực",
    "missingTokenMessage": "Vui lòng sử dụng link từ email để xác thực."
  },
  "invite": {
    "title": "Tham gia lớp học",
    "subtitle": "Đặt tên và mật khẩu để nhận lời mời và tham gia.",
    "fullName": "Họ tên",
    "fullNamePlaceholder": "Nguyễn Văn A",
    "password": "Mật khẩu",
    "passwordHint": "Nếu bạn đã có tài khoản với email này, cứ đặt mật khẩu bất kỳ. Hệ thống chỉ thêm bạn vào lớp.",
    "submit": "Tham gia",
    "submitting": "Đang xử lý...",
    "successTitle": "Đã tham gia!",
    "successMessage": "Bạn đã được thêm vào lớp. Hãy đăng nhập để tiếp tục.",
    "minLength": "Mật khẩu phải có ít nhất 8 ký tự.",
    "invalidToken": "Token không hợp lệ. Vui lòng thử lại từ email."
  }
}
